module.exports = __webpack_public_path__ + "static/Downloadable_Digital_Sabbath_Small_Group_Curriculum-cf7925330fa7e7ad0045dd8f0846876c.pdf";